export default "__VITE_ASSET__Bv9gb4fE__"